export enum SpecificationType {
    Standard = 1,
    ServingPortion,
    DailyValue,
    LabelClaim
}
